import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Modal, ModalProps, ModalWrapper } from '@shared/ui/organisms';
import { withTheme } from '@shared/lib/theme';
import ModalContent from './ModalContent';
type WhereToFindSteamLoginModalDesktopProps = ModalProps;
const WhereToFindSteamLoginModalDesktop: FC<WhereToFindSteamLoginModalDesktopProps> = ({
  open,
  onClose
}) => <Modal mobile open={open} onClose={onClose}>
    <ModalWrapper>
      <ContentWrapper>
        <ModalContent onClose={onClose} />
      </ContentWrapper>
    </ModalWrapper>
  </Modal>;
export default WhereToFindSteamLoginModalDesktop;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1ffhybl",
  propsAsIs: false,
  vars: {
    "c1ffhybl-0": [_exp()]
  }
}));

require("./WhereToFindSteamLoginModalDesktop.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./WhereToFindSteamLoginModalDesktop.tsx");